import React from "react";

export default function TrackingTimeline({ events }) {
    return (
        <div className="bg-white p-5 rounded-cb-md">
            <h3 className="mb-4 text-lg font-semibold text-[#1d2f5b]">Order History</h3>

            <div className="relative pl-4">
                {events.map((e, index) => {
                    const isLast = index === events.length - 1;
                    const [dateSegment, ...timeSegments] = (e.dateTime || "").split(" ");
                    const timeSegment = timeSegments.join(" ");

                    return (
                        <div key={index} className="relative pb-7">

                            {!isLast && (
                                <div className="absolute left-[6px] top-3 bottom-0 w-[2px] bg-green-500 z-[1]"></div>
                            )}

                            <div className="absolute left-0 top-2 w-3 h-3 bg-green-500 rounded-full z-[2]"></div>

                            {/* CONTENT */}
                            <div className="ml-6">
                                <div className="flex items-baseline gap-2">
                                    <span className="text-sm font-semibold text-gray-600">{dateSegment || e.dateTime || "—"}</span>
                                    {timeSegment && (
                                        <span className="text-xs text-gray-500">{timeSegment}</span>
                                    )}
                                </div>



                                {e.description && (
                                    <div className="mt-1 text-[12px] text-gray-500">
                                        {e.description}
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
